/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, Button, Grid } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Service';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import SearchNotFound from '../../../SearchNotFound';
import permissionAuth from 'src/utils/permissionAuth';
import { CustomTable } from './CustomTable';



export default function ProductListing(props) {
    const screenCode = 'PRODUCT';
    const [productList, setProductList] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    let encrypted = "";
    const navigate = useNavigate();
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 5,
    });

    const [formData, setFormData] = useState({
        productCategoryID: "0"
    });
    const [globalFilter, setGlobalFilter] = useState('');
    const productcatogerySearchSchema = Yup.object().shape({
    });

    const formik = useFormik({
        initialValues: {
            productCategoryID: formData.productCategoryID
        },
        validationSchema: productcatogerySearchSchema,
        onSubmit: (values) => {
            setProductList([]);
            trackPromise(GetProductDetails(values.productCategoryID));
        },
    });

    const { errors, touched, handleSubmit, setValues, isSubmitting, getFieldProps, values } = formik;
    const [editProduct, setEditProduct] = useState(0);
    const [canAddEdit, setCanAddEdit] = useState(false);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    useEffect(() => {
        const storedProductDetailsFormData = JSON.parse(sessionStorage.getItem('productDetailsFormData'));
        const storedPage = JSON.parse(sessionStorage.getItem('productDetailsPageData'));
        const storedSearch = JSON.parse(sessionStorage.getItem('productDetailsSearchData'));
        getPermissions(storedProductDetailsFormData, storedPage, storedSearch);
        trackPromise(GetProductCategoties());
        sessionStorage.removeItem('productDetailsFormData');
        sessionStorage.removeItem('productDetailsPageData');
    }, []);

    useEffect(() => {
        if (editProduct != 0) {
            EditProduct(editProduct)
        }
    }, [editProduct]);

    useEffect(() => {
        setProductList([]);
    }, [formik.values.productCategoryID]);

    async function getPermissions(storedProductDetailsFormData, storedPage, storedSearch) {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWPRODUCT');
        var canEdit = permissions.find(p => p.permissionCode == 'ADDEDITPRODUCT');
        setCanAddEdit(canEdit !== undefined);

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        const isInitialLoading = storedProductDetailsFormData === null
        if (!isInitialLoading) {
            setValues({
                ...values,
                productCategoryID: parseInt(storedProductDetailsFormData.productCategoryID)

            });
            trackPromise(GetProductDetails(storedProductDetailsFormData.productCategoryID));
            if (storedPage !== null) {
                setPagination(storedPage);
            }
            if (storedSearch !== null) {
                setGlobalFilter(storedSearch);
            }
        }
    }

    async function GetProductCategoties() {
        var res = await services.GetProductCategotiesForDropDown()
        if (res != null) {
            setProductcatogery(res);
        }
    }

    async function GetProductDetails(ProductCategoryID) {
        var res = await services.GetProductDetails(ProductCategoryID)
        if (res.statusCode == "Success") {
            setProductList(res.data);
        }
        else {
            toast.error(res.message);
        }
    }

    async function EditProduct(productCategoryID) {
        sessionStorage.setItem('productDetailsFormData', JSON.stringify(values));
        sessionStorage.setItem('productDetailsPageData', JSON.stringify(pagination));
        sessionStorage.setItem('productDetailsSearchData', JSON.stringify(globalFilter));
        encrypted = AESEncryptionParam(productCategoryID.toString());
        navigate('/dashboard/product/addedit/' + encrypted)
    }

    function handleClick(datas) {
        sessionStorage.setItem('productDetailsFormData', JSON.stringify(values));
        sessionStorage.setItem('productDetailsPageData', JSON.stringify(pagination));
        sessionStorage.setItem('productDetailsSearchData', JSON.stringify(globalFilter));
        encrypted = AESEncryptionParam(datas.productID.toString());
        navigate('/dashboard/product/addedit/' + encrypted)
    }

    function generateProductCategoryDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(x.isActive == true ? <MenuItem key={x.productCategoryID} value={x.productCategoryID}>{x.productCategoryName}</MenuItem> : null)
            });
        }
        return items
    }

    function clearAll() {
        setValues({
            ...values,
            productCategoryID: 0
        })
        setProductList([]);
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Product Creation |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/product/addedit/" + AESEncryptionParam("0")}
                        btname="Add"
                        pageName="Product Details"
                        leftButtonHidden={!canAddEdit}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <Stack width={450}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Product Category "
                                        value={formik.values.productCategoryID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('productCategoryID')}
                                        error={Boolean(touched.productCategoryID && errors.productCategoryID)}
                                        helperText={touched.productCategoryID && errors.productCategoryID}
                                    >
                                        <MenuItem key={0} value={0}> Select Product Category</MenuItem>
                                        {generateProductCategoryDropDownMenu(productcatogery)}
                                    </TextField>
                                </Stack>
                                <Grid item md={8} xs={12}>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                        > Clear</Button>
                                        <Button
                                            type="submit"
                                            color='secondary'
                                            variant="outlined"
                                        >Search</Button>
                                    </Stack>
                                </Grid>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {productList.length > 0 ?
                        <Card>
                            <CustomTable tableData={productList}
                                setEditProduct={setEditProduct}
                                pagination={pagination}
                                setPagination={setPagination}
                                globalFilter={globalFilter}
                                setGlobalFilter={setGlobalFilter}
                                canAddEdit={canAddEdit} />
                        </Card>
                        : <SearchNotFound searchQuery="Products" />

                    }
                </Container>
            </Page>
        </>
    );
}